// extracted by mini-css-extract-plugin
module.exports = {"scenarioTableRoot":"CwBzTZzZ","tableRoot":"cLdYh35Q","insightsWrapper":"okDKXSSG","tickerCell":"Qknt9JXe","wrapperEmptyAssetsState":"wvlEzb5D"};